import { hasPremiumDifference } from "../importedInvoiceUtils";

export interface EntryColumnConfig {
  columnId: string;
  width: number;
  reorderable: boolean;
  resizable: boolean;
  sortable: boolean;
  label: string;
  cellType: string;
  additionalInfo?: {
    rowIdField?: string;
    fractionDigits?: number;
    redColorFn?: (entry: any) => boolean;
    gosLink?: {
      idField: string;
      linkType: "policy" | "client" | "payer" | "insurer";
    };
  };
}

// detail grid: the member offers of the selected invoice and the installment each one was matched to
export const importedInvoiceEntriesColumnConfig: EntryColumnConfig[] = [
  {
    columnId: "ordinalNumber",
    width: 40,
    reorderable: false,
    resizable: true,
    label: "",
    cellType: "ordinalnumber",
    sortable: false,
  },
  {
    columnId: "vin",
    width: 170,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.vehicleIdentificationNumber.label",
    cellType: "customtext",
  },
  {
    columnId: "insuranceLine",
    width: 80,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.insuranceLine.label",
    cellType: "customtext",
  },
  {
    columnId: "insurerDisplayName",
    width: 160,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.insurerName.label",
    cellType: "customtext",
    additionalInfo: {
      gosLink: {
        idField: "insurerId",
        linkType: "insurer",
      },
    },
  },
  {
    columnId: "clientDisplayName",
    width: 200,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.clientName.label",
    cellType: "customtext",
    additionalInfo: {
      gosLink: {
        idField: "clientId",
        linkType: "client",
      },
    },
  },
  {
    columnId: "clientCode",
    width: 110,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.clientCode.label",
    cellType: "customtext",
  },
  {
    columnId: "premiumAmount",
    width: 100,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.premiumAmount.label",
    cellType: "customnumber",
    additionalInfo: {
      redColorFn: (entry) => hasPremiumDifference(entry),
    },
  },
  {
    columnId: "policyNumberPaymentPlanEntry",
    width: 150,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.policyNumberPaymentPlanEntry.label",
    cellType: "customtext",
    additionalInfo: {
      gosLink: {
        idField: "policyIdPaymentPlanEntry",
        linkType: "policy",
      },
    },
  },
  {
    columnId: "premiumAmountPaymentPlanEntry",
    width: 100,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.premiumAmountPaymentPlanEntry.label",
    cellType: "customnumber",
    additionalInfo: {
      redColorFn: (entry) => hasPremiumDifference(entry),
    },
  },
  {
    columnId: "clientNamePaymentPlanEntry",
    width: 200,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.importedInvoiceClientNamePaymentPlanEntry.label",
    cellType: "customtext",
    additionalInfo: {
      gosLink: {
        idField: "clientIdPaymentPlanEntry",
        linkType: "client",
      },
    },
  },
  {
    columnId: "validFromPaymentPlanEntryFormatted",
    width: 100,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.validFrom.label",
    cellType: "customtext",
  },
  {
    columnId: "isPaidPaymentPlanEntry",
    width: 60,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.isPaid.label",
    cellType: "customcheckmark",
  },
  {
    columnId: "paymentDateFormatted",
    width: 100,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.paymentDate.label",
    cellType: "customtext",
  },
  {
    columnId: "candidateCount",
    width: 80,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.importedInvoiceCandidateCount.label",
    cellType: "customnumber",
    additionalInfo: {
      fractionDigits: 0,
      // the VIN is known to GOS but no installment matched (insurer, line or premium differ)
      redColorFn: (entry) =>
        entry["candidateCount"] > 0 &&
        (entry["paymentPlanEntryId"] === null || entry["paymentPlanEntryId"] === undefined),
    },
  },
  {
    columnId: "offerId",
    width: 90,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.importedInvoiceOfferId.label",
    cellType: "customtext",
  },
];
